import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import theme from 'theme'

import { default as UIArrowLink } from '@anvilco-pkg/ui/components/links/ArrowLink'

import UniversalLink from 'components/UniversalLink'

// TODO: some of these styles are coming from the UIArrowLink component, but some reason
// they are being overridden by the styled component on first render. A refresh fixes it.
// it seems that the CSS is on the page, just that the className isn't being applied to this
// component. This is a temporary fix to get the styles to work.
export const StyledArrowLink = styled(UIArrowLink)`
  && {
    margin-top: 20px;
    width: fit-content;
    align-items: center;
    font-weight: 600;
    color: ${theme.colors.black};
  }

  && a {
    width: fit-content;
    text-decoration: none !important;
  }

  &:hover {
    a,
    span {
      color: ${theme.textColors.link};
    }

    span svg path,
    span svg rect,
    svg.icon-dynamic-arrow path,
    svg.icon-dynamic-arrow rect {
      /* might not even want this.. makes svgs in children blue on hover */
      fill: ${theme.textColors.link};
    }
  }
`

const ArrowLink = ({ className, component, icon, width, ...others }) => {
  return (
    <StyledArrowLink
      component={component}
      className={className || 'arrow-link'}
      icon={icon}
      width={width}
      {...others}
    />
  )
}

export const plasmicProps = {
  direction: {
    type: 'string',
    defaultValue: 'right',
  },
  children: {
    type: 'string',
    defaultValue:
      'Collaborating with a team? View team plans for additional seats',
  },
  width: {
    type: 'number',
    defaultValue: 50,
  },
  icon: 'string', // TODO: update this
}

ArrowLink.defaultProps = {
  component: UniversalLink,
  direction: 'right',
  width: 50,
}

ArrowLink.propTypes = {
  className: PropTypes.string,
  component: PropTypes.node,
  children: PropTypes.node.isRequired,
  direction: PropTypes.string,
  width: PropTypes.number,
  icon: PropTypes.node,
}

export default ArrowLink
